import { createAddCashdeskModal } from 'features/add-cashdesk';
import { createBlockCashdeskModal } from 'features/block-cashdesk';
import { createDeleteCashdeskModal } from 'features/delete-cashdesk';
import { createDepositCashdeskModal } from 'features/deposit-cashdesk';
import { createEditCashdeskModal } from 'features/edit-cashdesk';
import { createUnblockCashdeskModal } from 'features/unblock-cashdesk';
import { createWithdrawCashdeskModal } from 'features/withdraw-cashdesk';
import { createCashdeskRegistry } from 'entities/cashdesk';
import { accountPageCashdesksModel } from '../../model';
import cls from './account-page-cashdesks.module.scss';

const CashdeskRegistry = createCashdeskRegistry(accountPageCashdesksModel.cashdeskRegistryModel);

const AddCashdeskModal = createAddCashdeskModal(accountPageCashdesksModel.addCashdeskModel);

const DepositCashdeskModal = createDepositCashdeskModal(
	accountPageCashdesksModel.depositCashdeskModel,
);

const WithdrawCashdeskModal = createWithdrawCashdeskModal(
	accountPageCashdesksModel.withdrawCashdeskModel,
);

const EditCashdeskModal = createEditCashdeskModal(accountPageCashdesksModel.editCashdeskModel);

const BlockCashdeskModal = createBlockCashdeskModal(accountPageCashdesksModel.blockCashdeskModel);

const UnblockCashdeskModal = createUnblockCashdeskModal(
	accountPageCashdesksModel.unblockCashdeskModel,
);

const DeleteCashdeskModal = createDeleteCashdeskModal(
	accountPageCashdesksModel.deleteCashdeskModel,
);

export const AccountPageCashdesks = () => (
	<>
		<CashdeskRegistry
			withTitle={false}
			withAccount={false}
			className={cls.accountPageCashdesksCashdeskRegistry}
			emptyActionSlot={<AddCashdeskModal.Button />}
			topBarActionSlot={<AddCashdeskModal.Button />}
			tableTdActionSlot={(cashdesk) => (
				<div className={cls.accountPageCashdesksActions}>
					<div className={cls.accountPageCashdesksActionsGroup}>
						<WithdrawCashdeskModal.Button
							fullWidth
							modalData={cashdesk}
						/>
						<DepositCashdeskModal.Button
							fullWidth
							modalData={cashdesk}
						/>
					</div>
					<div className={cls.accountPageCashdesksActionsGroup}>
						<EditCashdeskModal.ActionIcon modalData={cashdesk} />
						{cashdesk.isLocked ? (
							<UnblockCashdeskModal.ActionIcon modalData={cashdesk} />
						) : (
							<BlockCashdeskModal.ActionIcon modalData={cashdesk} />
						)}
						<DeleteCashdeskModal.ActionIcon modalData={cashdesk} />
					</div>
				</div>
			)}
		/>
		<DepositCashdeskModal />
		<EditCashdeskModal />
		<BlockCashdeskModal />
		<UnblockCashdeskModal />
		<DeleteCashdeskModal />
		<AddCashdeskModal />
		<WithdrawCashdeskModal />
	</>
);
